import {VoicemailTemplateVariable} from "@/helpers/voicemail_template_helpers";
import {
  OptionalMarker,
  RequiredMarker,
  StyledTextarea,
  TemplateField,
  TemplateLabel,
  VariableHint
} from "@/components/pages/settings/telephony/VoicemailConfigsForm.styles";

type Props = {
  id: string;
  labelText: string;
  value: string;
  placeholder: string;
  supportedVariables: VoicemailTemplateVariable[];
  required?: boolean;
  onChange: (value: string) => void;
}

export default function VoicemailTemplateField({
  id,
  labelText,
  value,
  placeholder,
  supportedVariables,
  required = false,
  onChange,
}: Props) {
  return (
    <TemplateField>
      <TemplateLabel htmlFor={id}>
        {required && <RequiredMarker>* </RequiredMarker>}
        {labelText}
        {!required && <OptionalMarker> optional</OptionalMarker>}
      </TemplateLabel>
      <StyledTextarea
        id={id}
        name={id}
        rows={4}
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
      <VariableHint>
        Variables: {supportedVariables.map((variable) => `{${variable}}`).join(', ')}
      </VariableHint>
    </TemplateField>
  );
}
